export enum TicketPriorities {
  HIGH = 'Prioridade Alta',
  MEDIUM = 'Prioridade Média',
  LOW = 'Prioridade Baixa',
  WAITING_DEFINITION = 'Aguardando definição',
}

export enum TicketManagementPriorities {
  HIGH = 'Alta',
  MEDIUM = 'Média',
  LOW = 'Baixa',
  WAITING_DEFINITION = 'Aguardando definição',
}

export const TicketPrioritiesColors = {
  HIGH: 'negative.primary',
  MEDIUM: 'alert.primary',
  LOW: 'info.secondaryAlt',
  WAITING_DEFINITION: 'element.disabled',
};
